import React from 'react';
import { ButtonV3 } from '@pulsarml/avalon-ui';
import { I18n } from '@utils/i18n';
import LoginV2 from 'pages/login-v2/login-page-v2';
import LoginPageLayout from 'pages/login-v2/login-page-layout';
import { useDocsLogin } from './useDocsLogin';
import { docsRetryUrl } from './docsAccessRequest';

const LINK_CLASS =
  'tw-text-[#2aa276] tw-underline hover:tw-text-[#2aa276] hover:tw-no-underline';

export function DocsAccessPage() {
  const {
    isAuthenticated,
    isLoading,
    checkingSession,
    request,
    failed,
    pending,
    retry,
    cancel
  } = useDocsLogin();
  if (!checkingSession && !isLoading && request && !isAuthenticated)
    return (
      <LoginPageLayout>
        <LoginV2 />
      </LoginPageLayout>
    );

  let messageKey = 'docs_access_opening';
  if (failed) messageKey = 'docs_access_failed';
  else if (checkingSession) messageKey = 'docs_access_checking';
  else if (!request) messageKey = 'docs_access_expired';
  const expired = messageKey === 'docs_access_expired';
  const retryUrl = expired
    ? docsRetryUrl(window.location.search, I18n._locale)
    : null;

  return (
    <LoginPageLayout>
      <div
        className="tw-p-6 tw-text-center tw-text-[#f5f5f7]"
        role={failed || expired ? 'alert' : 'status'}
      >
        <p>{I18n.t(messageKey)}</p>
        {request && failed && (
          <ButtonV3 onClick={retry} disabled={pending}>
            {I18n.t('docs_access_retry')}
          </ButtonV3>
        )}
        {retryUrl && (
          <a className={LINK_CLASS} href={retryUrl}>
            {I18n.t('docs_access_retry')}
          </a>
        )}
        {(failed || expired) && (
          <a
            className={`tw-mt-4 tw-block ${LINK_CLASS}`}
            href="/"
            onClick={cancel}
          >
            {I18n.t('docs_access_back')}
          </a>
        )}
      </div>
    </LoginPageLayout>
  );
}
